import React, { Component } from "react"

class Highlight extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      popup: false
    }
  }

  renderChild () {
    let current = this.props.content;

    if (this.props.search != ""){
      let search = new RegExp(this.props.search, "ig");
      let orig = search.exec(current)

      return current.replace(search, `<span style="background: var(--yellow); border-radius: 7px;">${orig}</span>`);
    }

    return current;
  }

  bodyMatches () {
    if (this.props.search != "" && this.props.additional != null && this.props.search.length >= 3){
      let search = new RegExp(`${this.props.search}.{1,50}`, "ig");
      let count = this.props.additional.match(search)

      if(count && count.length > 0){

        return (
          <div id={this.props.id} className="search-chips" onMouseEnter={() => this.handleMouseEnter()} onMouseLeave={() => this.handleMouseLeave()}>

            {count.length + ` match${(count.length === 1 ? "" : "es")} in the post`}

            <div id={`popup-${this.props.id}`} className={(this.state.popup ? "chip-hover active" : "chip-hover")}>
              <div className="pu-content">
                <div style={{
                    background: "var(--deep-blue)",
                    flexBasis: "100%",
                    padding: "5px 10px",
                    color: "white",
                    borderRadius: "5px 5px 0 0"
                  }}>Matching: {this.props.search}</div>
                {count.map((blurb) => {

                  var pattern = new RegExp(this.props.search, "ig")
                  let newBlurb = blurb.replace(pattern, `<span style="color: red">${this.props.search}</span>`)

                  return <p dangerouslySetInnerHTML={{__html: `${newBlurb}...`}}/>
                })}

              </div>
            </div>
          </div>)

      } else {
        return ""
      }
    }
  }

  componentDidUpdate () {
    // var elID = this.props.id
    // var chip = document.getElementById(elID)
    //
    // var handleMouse = function (id, el) {
    //   console.log(id, el);
    //   let popup = document.getElementById(`popup-${id}`)
    //   console.log(popup);
    //   popup.classList.add("active")
    //
    //   el.addEventListener("mouseleave", function x () {
    //     document.getElementById(`popup-${id}`).classList.remove("active");
    //   })
    // }
    //
    // if(chip) {
    //   chip.addEventListener('mouseenter', handleMouse(elID, chip))
    // }
  }

  handleMouseEnter () {
    this.setState({
      popup: true
    })
  }

  handleMouseLeave () {
    this.setState({
      popup: false
    })
  }

  render () {
    return (
      <div className="basicFlex wrap">
        <h4 style={{flexBasis: "100%"}} dangerouslySetInnerHTML={{__html: this.renderChild()}}></h4>
        {this.bodyMatches()}
      </div>
    )
  }
}

export default Highlight;

// Highlight.propTypes = {
//   children: PropTypes.node.isRequired,
// }
